import { useState } from "react";

// lib
import { Firestore } from "lib/firebase";
import { Hero } from "shared/components/bulma/hero";
import { Link } from "react-router-dom";
import { Level } from "shared/components/bulma/level";
import { LevelItem } from "shared/components/bulma/level";

const CHECKOUT_PREFIX = 'checkout-v';

const Admin = () => {

    const [users, setUsers] = useState([]);
    const [version, setVersion] = useState(CHECKOUT_PREFIX + '3.0.1');

    const handleChange = (event) => {
        const { value } = event.target;
        setVersion(CHECKOUT_PREFIX + value);
    }

    const handleClick = async () => {
        const d = await Firestore.collection('users')
            .where('landed_on_checkout', '==', version)
            .get();

        const us = d.docs.map((doc) => Object({ ...doc.data(), id: doc.id }));
        setUsers(us);
    }

    return (
        <>
            <Hero className="is-light">
                <div className="field has-addons">
                    <div className="control is-expanded">
                        <input className="input"
                            onChange={handleChange}
                            type="text" placeholder="Version like 3.0.1" />
                    </div>
                    <div className="control">
                        <button
                            onClick={handleClick}
                            className="button is-primary">
                            Search
                        </button>
                    </div>
                </div>

                <div className="mt-6" />

                <Level>
                    <LevelItem heading="version" value={version} />
                    <LevelItem heading="Total" value={users.length} />
                    <LevelItem heading="Paid"
                        value={users.filter((u) => u.registration_source === version).length} />
                </Level>
            </Hero>

            <Hero>

                {users.map((user) => (
                    <>
                        <Link key={user.id} to={`/closet-hackers/${user.id}?tab=Settings`}>
                            <div className="block has-background-primary-light p-6 mb-4">
                                {user.full_name || 'No Name Yet'} | <small>{user.country}</small>
                                <br />
                                {user.email}


                                {(user.registration_source === version) && (
                                    <span className="icon is-size-1 has-text-success mx-6">
                                        <i className="fas fa-money"></i>
                                    </span>
                                )}
                            </div>
                        </Link>
                    </>
                ))}
            </Hero>
        </>
    );
}

export default Admin;
